import type { Contact } from '@features/contacts/types/contact'

export const getPrimaryContactNameAndEmail = (contact: Contact): string[] => {
  const primaryContact =
    contact.contactPersons?.find((contactPerson) => contactPerson.isPrimary) || contact.contactPersons?.[0]
  if (!primaryContact) {
    return []
  }

  const contactName = primaryContact.name || primaryContact.fullName || ''
  return [contactName, primaryContact.email ?? ''].filter(Boolean)
}
